import { Block, Grid } from '@aloft/toolkit-sui';
import { ViewMode } from '../types.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { selectArvFilteredCompSequence, selectIsArvOrder } from '../../../redux/features/selectors/orderSelectors.ts';
import { ColumnSection } from '../../../components/Analysis/ColumnComponents/ColumnSection.tsx';
import { selectAivArvActiveTab } from '../../../redux/features/selectors/uiSelectors.ts';
import { useHeaderByID } from './HeaderByID.tsx';
import { useIndicatedCostByID } from './IndicatedCostByID.tsx';
import { useSlidersByID } from './SlidersByID.tsx';
import { useSummaryByID } from './SummaryByID.tsx';
import { AppraisifyAnalysisGraphs } from './AppraisifyAnalysisGraphs.tsx';

export const AppraisifyAnalysisGrid = ({ viewMode }: { viewMode: ViewMode }) => {
  const filteredCompSequence = useAppSelector(selectArvFilteredCompSequence);
  const includeArv = useAppSelector(selectIsArvOrder);
  const arvTab = useAppSelector(selectAivArvActiveTab);

  const HeaderByID = useHeaderByID();
  const IndicatedCostByID = useIndicatedCostByID(arvTab);
  const SlidersByID = useSlidersByID(viewMode, arvTab);
  const SummaryByID = useSummaryByID();

  return (
    <Block overflow="auto" paddingLeft="10px">
      <Grid
        className="analysis-grid"
        gridTemplateColumns={`repeat(${filteredCompSequence.length + 1}, 1fr)`}
        maxWidth="500px"
      >
        <ColumnSection
          className="analysis-grid-property-header"
          compSequence={filteredCompSequence}
          contentFill
          renderForId={HeaderByID}
        />
        <ColumnSection
          className="indicated-cost"
          compSequence={filteredCompSequence}
          renderForId={IndicatedCostByID}
          aivArvTab={includeArv ? arvTab : undefined}
        />
        <ColumnSection
          className="sliders"
          compSequence={filteredCompSequence}
          renderForId={SlidersByID}
          backgroundColor="surface2"
          aivArvTab={includeArv ? arvTab : undefined}
        />
        <ColumnSection
          className="summary"
          compSequence={filteredCompSequence}
          renderForId={SummaryByID}
          backgroundColor="surface2"
          aivArvTab={includeArv ? arvTab : undefined}
        />
      </Grid>
      <AppraisifyAnalysisGraphs />
    </Block>
  )
}
